import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import { ChildrenPropType } from 'src/utils/types';
import { MaterialErrorMessage } from 'src/components/UI/common/MaterialErrorMessage';
import { UiMereLabel } from 'src/components/UI/UiMereLabel';

type Props = {
  children: ChildrenPropType;
  active: boolean;
  hasErrors: boolean;
  hasValue: boolean;
  disabled: boolean | undefined;
  errorMessage: string | undefined;
  placeholder: string | ReactNode | undefined;

  className?: string;
  placeholderClassName?: string;
};

export const InputMaterialWrapper: FC<Props> = ({
  children,
  active,
  disabled,
  hasErrors,
  errorMessage,
  placeholder,
  hasValue,
  className,
  placeholderClassName,
}) => (
  <div
    className={classNames(className, 'input-field-material custom', {
      noPlaceholder: !placeholder,
      active: active || hasValue,
      disabled,
    })}
    role="presentation"
  >
    {children}

    {placeholder && (
      <UiMereLabel className={classNames('input-label', placeholderClassName, { active: active || hasValue })}>
        {placeholder}
      </UiMereLabel>
    )}

    <MaterialErrorMessage error={hasErrors && errorMessage} />
  </div>
);
